import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
import DynamicTable from "../../../components/tables/Dynamictable";
import { UserApi } from "../../../API/userApi";
import useToast from "../../../hooks/useToast";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";

const InterestedUsersPage: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showError } = useToast();

  const [interestedUsers, setInterestedUsers] = useState<any[]>([]);
  const [propertyDetails, setPropertyDetails] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await UserApi.getInterestedUsers(id);

        console.log("responseresponse", response)
        setInterestedUsers(response?.interestedUsers || []);
        setPropertyDetails(response?.propertyDetails || null);
      } catch (error) {
        showError("Failed to fetch data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // ✅ Columns for Interested Users Table
  const columns = [
    { title: "S. No.", dataIndex: "serialNo", key: "serialNo", width: 80 },
    { title: "User Name", dataIndex: "userName", key: "userName", width: 200 },
    { title: "Email", dataIndex: "email", key: "email", width: 250 },
    { title: "Phone", dataIndex: "phone", key: "phone", width: 200 },
    { title: "Role", dataIndex: "role", key: "role", width: 150 },
  ];

  // ✅ Data Mapping for Interested Users
  const data = interestedUsers.map((user: any, index: number) => ({
    key: user.id || index.toString(),
    serialNo: index + 1,
    userName: user.name || "N/A",
    email: user.email || "N/A",
    phone: user.phone || "N/A",
    role: user.role || "user",
  }));

  return (
    <>
      <PageMeta title="Interested Users" description="List of interested users for the selected property" />
      <PageBreadcrumb pageTitle="Interested Users Table" />

      <div className="container mx-auto p-6 space-y-6 overflow-hidden max-w-full">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-semibold">Interested Users</h1>
          <button
            onClick={() => navigate("/properties")}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Back to Properties
          </button>
        </div>

        {/* ✅ Property Details Section - Show in a single row */}
        {propertyDetails && (
          <div className="bg-gray-100 p-4 rounded-md shadow-sm border border-gray-300 mb-6">
            <h2 className="text-lg font-semibold text-gray-800">Property Details</h2>
            <div className="flex space-x-6">
              <p className="text-gray-700">
                <strong className="text-gray-900">Property ID:</strong> {id}
              </p>
              <p className="text-gray-700">
                <strong className="text-gray-900">Type:</strong> {propertyDetails.type || "N/A"}
              </p>
              <p className="text-gray-700">
                <strong className="text-gray-900">Location:</strong> {propertyDetails.location || "Unknown Location"}
              </p>
              <p className="text-gray-700">
                <strong className="text-gray-900">Price:</strong> {propertyDetails.price || "N/A"}
              </p>
            </div>
          </div>
        )}

        {/* ✅ Interested Users Table */}
        <DynamicTable columns={columns} data={data} loading={loading} rowsPerPage={5} />
      </div>
    </>
  );
};

export default InterestedUsersPage;
